import account from './account';
import master from './master';
import dashboard from './dashboard';
import content from './content';
import mentors from './mentors';
import subscriptions from './subscriptions';
import commentSection from "./comment";
import referralSection from "./referral";
import readMore from "./readMore";
import parameters from "./Parameters";
import masterData from "./masterData";
import invoiceListSection from "./invoiceList";
import expiringSubscribersSection from "./expiringSubscribers";
import supportReportsSection from "./supportReports";
import churnCohortSection from "./churnCohort";
import churnExitSurveySection from "./churnExitSurvey";
import churnHealthDistributionSection from "./churnHealthDistribution";
import churnWorklistSection from "./churnWorklist";
import churnScorecardSection from "./churnScorecard";
import churnScorecardTargetsSection from "./churnScorecardTargets";
import churnWeeklyIndicatorsSection from "./churnWeeklyIndicators";
import churnDigestSection from "./churnDigest";
import churnRetentionLogSection from "./churnRetentionLog";
import churnMessageTemplatesSection from "./churnMessageTemplates";
import churnOnboardingStatusSection from "./churnOnboardingStatus";

export {
    account,
    master,
    dashboard,
    content,
    mentors,
    subscriptions,
    commentSection,
    referralSection,
    invoiceListSection,
    expiringSubscribersSection,
    supportReportsSection,
    churnCohortSection,
    churnExitSurveySection,
    churnHealthDistributionSection,
    churnWorklistSection,
    churnScorecardSection,
    churnScorecardTargetsSection,
    churnWeeklyIndicatorsSection,
    churnDigestSection,
    churnRetentionLogSection,
    churnMessageTemplatesSection,
    churnOnboardingStatusSection,
    readMore,
    parameters,
    masterData
}
export default {
    account,
    master,
    dashboard,
    content,
    mentors,
    subscriptions,
    commentSection,
    referralSection,
    invoiceListSection,
    expiringSubscribersSection,
    supportReportsSection,
    churnCohortSection,
    churnExitSurveySection,
    churnHealthDistributionSection,
    churnWorklistSection,
    churnScorecardSection,
    churnScorecardTargetsSection,
    churnWeeklyIndicatorsSection,
    churnDigestSection,
    churnRetentionLogSection,
    churnMessageTemplatesSection,
    churnOnboardingStatusSection,
    readMore,
    parameters,
    masterData
}
